import '@mindscreen/imagegallery/Resources/Public/JavaScript/frontend';
import '@mindscreen/imagegallery/Resources/Public/Css/frontend.css';
import { Accordion } from '@mindscreen/nodetypes/Fusion/Components/MultiPanel';

import '../Scss/Base.scss';

import '@stst/components/Form';
import '@stst/components/Dialog';
import '@stst/components/FlashMessages';
import '@stst/components/General';
import '@stst/components/Project';
import '@stst/components/Header';
import '@stst/components/Page';
import '@stst/components/Footer';
import '@stst/components/Navigation';
import '@stst/components/Contact';
import '@stst/components/Event';
import '@stst/components/News';
import '@stst/components/Stage';
import '@stst/components/Search';
import '@stst/components/Donations/Amount';
import '@stst/components/Video';
import '@stst/components/ShareWidget';
import { forAll } from '@stst/Javascript/util';

if (!document.body.classList.contains('neos-backend')) {
    forAll('.js-accordion', e => new Accordion(e, 'accordion'));
}
